import moment from 'moment';
import fp from 'lodash/fp';

import {
    dateTimeTransferFormat,
    dateTimeDisplayFormat,
    dateTransferFormat,
    dateDisplayFormat
} from './constants';

export const getTimeStamp = () => moment().unix();

export const dateTimeToMoment = (dateTime) => moment(dateTime, dateTimeTransferFormat);
export const dateToMoment = (date) => moment(date, dateTransferFormat);

// eslint-disable-next-line max-len
export const dateTimeToDisplay = (dateTime) => moment(dateTime, dateTimeTransferFormat).format(dateTimeDisplayFormat);
export const dateToDisplay = (date) => moment(date, dateTransferFormat).format(dateDisplayFormat);

export const urlEncodeFilter = (raw) => (raw && typeof raw === 'object' && raw.constructor === Object
    ? `?${Object.entries(raw).map((e) => `${e[0]}=${encodeURIComponent(JSON.stringify(e[1]))}`).join('&')}`
    : `?${encodeURIComponent(JSON.stringify(raw))}`
);

export const urlDecodeFilters = (raw) => raw.replace(/\?/, '').split('&').reduce((acc, cur) => ({ ...acc, [cur.split('=')[0]]: JSON.parse(decodeURIComponent(cur.split('=')[1])) }), {});

export const getTimeSinceLastUpdated = (lastUpdated) => (
    lastUpdated ? getTimeStamp() - lastUpdated : 0
);

export const secondsToTimeAgo = (seconds) => {
    if (seconds < 10) return 'just now';

    if (seconds < 60) return `${seconds} seconds ago`;

    if (seconds < (60 * 60)) {
        const minutes = Math.floor(seconds / 60);
        return minutes === 1 ? 'a minute ago' : `${minutes} minutes ago`;
    }

    const hours = Math.floor(seconds / (60 * 60));

    return hours === 1 ? 'an hour ago' : `${hours} hours ago`;
};

export const withDispatch = (data) => (dispatch) => fp.mapValues(fp.mapValues(
    (action) => fp.compose(dispatch, action)
))(data);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const keys = Object.keys({ ...stateProps, ...dispatchProps });
    const merged = keys.reduce((partial, key) => ({
        ...partial,
        [key]: {
            ...stateProps[key],
            ...dispatchProps[key]
        }
    }), {});
    return {
        ...merged,
        ...ownProps
    };
};

export const fileUserDownload = (blobData, fileName, dataType = 'application/csv') => {
    const blob = new Blob([blobData], { type: dataType });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
